import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';
import { supabase } from '../lib/supabase';

export function Navbar() {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const isDashboardRoute = location.pathname.startsWith('/dashboard') || 
                          location.pathname.startsWith('/search') || 
                          location.pathname.startsWith('/emails') ||
                          location.pathname.startsWith('/replies') ||
                          location.pathname.startsWith('/');

  useEffect(() => {
    // Check initial auth state
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsAuthenticated(!!session);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <nav className={`${isDashboardRoute ? 'bg-gray-900 border-b border-gray-700' : 'bg-white shadow-sm'}`}>
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to={isAuthenticated ? "/dashboard" : "/"} className="flex items-center">
              <GraduationCap className={`h-8 w-8 ${isDashboardRoute ? 'text-indigo-400' : 'text-indigo-600'}`} />
              <span className={`ml-2 text-xl font-bold ${isDashboardRoute ? 'bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-purple-400' : 'text-gray-900'}`}>Research-X</span>
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <Link
              to="/pricing"
              className="text-white hover:text-indigo-300 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Pricing
            </Link>
            
            {/* Show Sign In button only when not authenticated */}
            {!isAuthenticated && (
              <Link
                to="/login"
                className="bg-gray-800 border border-gray-700 text-white hover:bg-gray-700 px-4 py-2 rounded-md text-sm font-medium transition-colors shadow-md"
              >
                Sign In
              </Link>
            )}
            
            {/* Show Get Started button only when not authenticated and not on dashboard */}
            {!isAuthenticated && !isDashboardRoute && (
              <Link
                to="/signup"
                className="bg-indigo-600 text-white hover:bg-indigo-700 px-4 py-2 rounded-md text-sm font-medium"
              >
                Get Started
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}